<template>
  <div class="p-box">
    <div class="p-box__body">
      <div v-if="!loading && available_plan">
        <div class="c-grid">
          <h2 class="c-pageTitle">{{ $t('pages.companies.paymentSetting.paymentMethod.title') }}</h2>
        </div>
        <div class="c-info">
          <div class="c-info__icon"><Icon name="iconQuestion" /></div>
          <div class="c-info__content">
            <p>{{ $t('pages.companies.paymentSetting.paymentMethod.info') }}</p>
          </div>
        </div>
        <div class="p-list">
          <ul class="p-list__items">
            <li class="p-list__item">
              <div class="p-list__title">{{ $t('pages.companies.paymentSetting.paymentMethod.currentPaymentMethod') }}: </div>
              <div class="p-list__content">{{ $t('pages.companies.paymentSetting.paymentMethod.annualPayment') }}</div>
            </li>
            <li class="p-list__item">
              <div class="p-list__title">{{ $t('pages.companies.paymentSetting.paymentMethod.nextBillingDate') }}:</div>
              <div class="p-list__content">{{ parsedNextPaymentAt }}</div>
            </li>
            <li class="p-list__item">
              <div class="p-list__title">{{ $t('pages.companies.paymentSetting.paymentMethod.nextBillingAmount') }}: </div>
              <div class="p-list__content">{{ $t('labels.currency.yen', { number: Number(available_plan.attributes.next_payment_amount).toLocaleString() }) }}</div>
            </li>
            <li class="p-list__item p-creditCard">
              <div class="p-list__title">{{ $t('pages.companies.paymentSetting.paymentMethod.creditCard.label') }}: </div>
              <div class="p-list__content p-creditCard__content">
                <div class="p-list p-creditCard__list">
                  <ul class="p-list__items p-creditCard__list__items">
                    <CreditCard />
                    <li class="p-list__item">
                      <form class="p-payjpCardForm" @submit.prevent="onSubmit">
                        <div ref="scriptHolder" />
                      </form>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <Loading v-show="loading" />
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import Loading from '../Loading'
import Icon from '../Icon'
import CreditCard from './CreditCard'

export default {
  name: 'PaymentMethod',
  components: {
    Loading,
    Icon,
    CreditCard,
  },
  data() {
    return {
      settingsPayjpPublicKey: gon.settingsPayjpPublicKey,
      payjpCheckoutErrorMessage: '',
    }
  },
  computed: {
    ...mapState({
      available_plan: state => state.companiesAvailablePlan.data,
      credit_cards: state => state.companiesCreditCards.data,
      loading: state => state.companiesAvailablePlan.loading
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    parsedNextPaymentAt: function () {
      return moment(new Date(this.available_plan.attributes.next_payment_at)).format(this.$t('format.date.default'))
    },
  },
  created() {
    this.readAvailablePlan(this.currentCompanyUuid)
  },
  updated() {
    this.$nextTick(function () {
      this.insertPayjpButton()
    })
  },
  methods: {
    ...mapActions({
      readAvailablePlan: 'companiesAvailablePlan/readAvailablePlan',
      writeCreditCards: 'companiesCreditCards/writeCreditCards',
    }),
    payjpStatusCheck(data) {
      if (data.card.cvc_check === 'failed' || data.card.cvc_check === 'unavailable') {
        this.payjpCheckoutErrorMessage = this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.invalid')
        alert(this.payjpCheckoutErrorMessage)
        return
      }
      this.payjpCheckoutErrorMessage = ''
    },
    async onSubmit(data) {
      this.payjpStatusCheck(data)
      await this.writeCreditCards(this.currentCompanyUuid)
      let button = document.getElementsByClassName('has-token')[0]
      button.classList.remove('has-token')
      button.value = this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.add')
    },
    insertPayjpButton() {
      if (!this.$refs.scriptHolder){
        return
      }

      window.onTokenCreated = this.onSubmit
      const scriptEl = document.createElement('script')
      scriptEl.setAttribute('src', 'https://checkout.pay.jp/')
      scriptEl.setAttribute('class', 'payjp-button')
      // public key
      scriptEl.setAttribute('data-key', this.settingsPayjpPublicKey)
      scriptEl.setAttribute('data-partial', 'true')
      scriptEl.setAttribute('data-lang', ['ja', 'en'].includes(this.$i18n.locale) ? this.$i18n.locale : 'ja')
      scriptEl.setAttribute('data-on-created', 'onTokenCreated')
      scriptEl.setAttribute('data-text', this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.add'))
      scriptEl.setAttribute('data-submit-text', this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.add'))
      this.$refs.scriptHolder.appendChild(scriptEl)
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
